module.exports = __webpack_public_path__ + "static/media/yearly fee icon.807306d8.svg";